module.exports = __webpack_public_path__ + "static/Claire-5853fe3fee88392d4b3dd065ccd6ab2c.png";